import { store } from 'shared/stores/core/decorators';

@store('IA_STATE')
export class ImageAnalysisStore {
  state = {
    // the "isVisible" status provides a mechanism to block updates to IA. This is desirable since IA consumes
    // resources, leaving fewer for uScope etc
    isVisible: false,
    // the "isEnabled" status is used to prevent the user from running image analysis
    isEnabled: false
  };

  getters = {
    // consolidate commonly referenced items in one store for IA
    imageId: ({state}) => state('IMAGE').selectedImageId,
    macroId: ({get}) => get('IA_MACROS').selectedMacroId,
    // The "Synthetic Key" will point to active batch coordinator (varies based on selected image/macro)
    syntheticKey: () => {
      return createSyntheticKey(this.getters.imageId, this.getters.macroId, this.state.isVisible);
    }
  };

  remap = {
    IMAGE_SELECTED: 'IA_EVALUATE_MACRO_STATE_ONLY',
    LAYERS_LOADED: 'IA_EVALUATE_MACRO_STATE_ONLY',
    IA_AFTER_SELECT_MACRO: 'IA_EVALUATE_STATE'
  };

  // state change tracking
  lastEvaluateImageId = null;
  lastEvaluatedState = null;

  // Command to evaluate the macro portion of IA state.
  IA_EVALUATE_MACRO_STATE_ONLY (store) {
    // 1. If IA isn't visible the user isn't interacting with it and there's nothing we need to do
    // 2. If the selected image id has changed (or was never set) it needs to be updated and the macro list needs updating
    // 3. If we don't have a selected MacroId we assume macros haven't been loaded, so we update the macro list (this is a first-run only condition)
    // 4. If the selected macro state looks good then we need to update the rest of IA state

    if (!this.state.isVisible || !this.getters.imageId) {
      return;
    }

    const hasImageIdChanged = this.lastEvaluateImageId !== this.getters.imageId;

    if (hasImageIdChanged || !this.getters.macroId) {
      this.lastEvaluateImageId = this.getters.imageId;
      store.dispatch('IA_LOAD_MACROS');
    } else {
      store.dispatch('IA_EVALUATE_STATE');
    }
  }

  IA_EVALUATE_STATE ({state, dispatch}) {
    const currentState = this.getters.syntheticKey;
    if (this.lastEvaluatedState !== currentState) {
      dispatch('IA_STATE_CHANGE');
      this.lastEvaluatedState = currentState;
    }
  }

  IA_SHOW_TOOLS ({dispatch}) {
    this.state.isVisible = true;
    dispatch('IA_EVALUATE_MACRO_STATE_ONLY');
  }

  IA_HIDE_TOOLS () {
    this.state.isVisible = false;
  }

  IA_LOCK_ANALYSIS () {
    this.state.isEnabled = false;
  }

  IA_UNLOCK_ANALYSIS () {
    this.state.isEnabled = true;
  }

  IA_ERROR ({dispatch}, {message}) {
    dispatch('USCOPE_NOTIFY', {
      type: 'error',
      message
    });
  }
}

export function createSyntheticKey (imageId, macroId, isVisible) {
  return (!imageId || !macroId || !isVisible) ? null : `${imageId}+${macroId}+${isVisible}`;
}



// WEBPACK FOOTER //
// ./src/shared/stores/image-analysis/ImageAnalysisStore.js